var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SessionReport"},_vm._l((_vm.items),function(item,i){return _c('Item',_vm._b({key:i},'Item',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }